import styled from 'styled-components';

interface ReviewTagProps {
  label: string;
}

const ReviewTag = ({ label }: ReviewTagProps) => {
  return <Tag>{label}</Tag>;
};

export default ReviewTag;

const Tag = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 99px;

  color: var(--gray-ui_gray05, #999);
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  letter-spacing: -0.24px;
`;
